import { render, staticRenderFns } from "./rescuecntloc.vue?vue&type=template&id=2a163e82"
import script from "./rescuecntloc.vue?vue&type=script&lang=js"
export * from "./rescuecntloc.vue?vue&type=script&lang=js"
import style0 from "./rescuecntloc.vue?vue&type=style&index=0&id=2a163e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports